// extracted by mini-css-extract-plugin
module.exports = {"vision":"style_vision__2UFSe","perspective":"style_perspective__1opG0","perspective-active":"style_perspective-active__QLYGV","vision-bg":"style_vision-bg__xkThZ"};